import React from 'react';
import {
  Box, Button, Chip, IconButton, Stack, Tooltip, Typography
} from '@mui/material';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from 'dayjs';

const DOC_TYPE_LABELS = {
  HR_LEAVE: '휴가 신청',
};

const REASON_TYPE_LABELS = {
  LEAVE: '휴가',
  BUSINESS_TRIP: '출장',
  ABSENCE: '부재',
  MANUAL: '수동',
};

const getStatusLabel = (row) => {
  if (row.activeYn !== 'Y') {
    return { label: '비활성', color: 'default' };
  }

  const today = dayjs().format('YYYY-MM-DD');
  if (today < row.strtDt) {
    return { label: '예정', color: 'info' };
  }
  if (today > row.endDt) {
    return { label: '종료', color: 'default' };
  }
  return { label: '적용중', color: 'success' };
};

const ApprovalDelegationTab = ({
  list,
  loading,
  onAdd,
  onEdit,
  onDelete,
}) => {
  const columns = [
    {
      field: 'docType',
      headerName: '대상 문서',
      minWidth: 130,
      flex: 0.7,
      renderCell: ({ value }) => DOC_TYPE_LABELS[value] || '전체 문서',
    },
    {
      field: 'delegateUsrNm',
      headerName: '대결자',
      minWidth: 120,
      flex: 0.7,
      valueFormatter: (value) => value || '-',
    },
    {
      field: 'period',
      headerName: '기간',
      minWidth: 220,
      flex: 1,
      renderCell: ({ row }) => `${row.strtDt} ~ ${row.endDt}`,
    },
    {
      field: 'reasonTyp',
      headerName: '사유',
      minWidth: 100,
      flex: 0.5,
      renderCell: ({ value }) => REASON_TYPE_LABELS[value] || value || '-',
    },
    {
      field: 'status',
      headerName: '상태',
      minWidth: 110,
      flex: 0.5,
      renderCell: ({ row }) => {
        const status = getStatusLabel(row);
        return <Chip label={status.label} color={status.color} size="small" />;
      },
    },
    {
      field: 'crtDt',
      headerName: '등록일',
      minWidth: 160,
      flex: 0.8,
      valueFormatter: (value) => value ? dayjs(value).format('YYYY-MM-DD HH:mm') : '-',
    },
    {
      field: 'actions',
      headerName: '',
      minWidth: 110,
      sortable: false,
      renderCell: ({ row }) => (
        <Stack direction="row" spacing={0.5}>
          <Tooltip title="수정">
            <IconButton size="small" color="primary" onClick={() => onEdit(row)}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="삭제">
            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];

  return (
    <Box>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <Box>
          <Typography variant="body2" fontWeight={600}>
            대결 관리
          </Typography>
          <Typography variant="caption" color="text.secondary">
            본인 결재를 다른 사용자에게 임시 위임합니다. 현재 대기 중인 문서에도 즉시 반영됩니다.
          </Typography>
        </Box>
        <Box sx={{ flex: 1 }} />
        <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={onAdd}>
          대결 등록
        </Button>
      </Stack>

      <DataGrid
        rows={list}
        columns={columns}
        getRowId={(row) => row.delegationId}
        loading={loading}
        autoHeight
        density="compact"
        disableRowSelectionOnClick
        sx={{ bgcolor: 'background.paper', borderRadius: 1 }}
      />
    </Box>
  );
};

export default ApprovalDelegationTab;
